@if ((authService.isAuthenticated$ | async) && usuario()) {
    <app-navbar></app-navbar>
}

<router-outlet></router-outlet>

<ngx-spinner bdColor="rgba(0,0,0,0.5)" size="medium" color="#fff" type="ball-clip-rotate">
  <p style="color: white; font-size: 14px; margin-top: 10px;">Cargando...</p>
</ngx-spinner>